import { useAuth } from "oidc-react";
import React, { useEffect, useRef, useState } from "react";
import Context from "./index";
import * as signalR from "@microsoft/signalr";
import { Snackbar } from "@mui/material";
import SnackbarCustom from "./SnackbarCustom";
import ringtone from "./audio.wav";

const SocketProvider = (props) => {
  const { userData } = useAuth();
  const [connection, setConnection] = useState();
  const [snackbarText, setSnackBarText] = useState();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [appName, setAppName] = useState("Benefits");
  const audioRef = useRef(null);
  // const AudioPlayer = () => {
  //   return (
  //     <>
  //       {" "}
  //       <audio
  //         ref={audioRef}
  //         src={"./audio.wav"}
  //         type="audio/mpeg"
  //         autoPlay={true}
  //       >
  //         Your browser does not support the audio element.
  //       </audio>
  //     </>
  //   );
  // };
  useEffect(() => {
    if (userData) {
      let APIURL = process.env.REACT_APP_API_DOTNET_URL;
      APIURL = APIURL?.replace("/api", "/chatHub");
      // Build and start the SignalR connection
      console.log("API URL: " + APIURL);
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(APIURL, {
          accessTokenFactory: () => userData?.access_token,
        }) // Replace with your server URL
        // .withAutomaticReconnect()
        .build();
      console.log("newConnection");
      // setConnection(newConnection);
      newConnection
        .start()
        .then((res) => {
          console.log("Connected using socket", res);

          // Define the receive message method
          newConnection.on("UserConnected", (user) => {
            console.log("Connected using socket ++ UserConnected", user);
          });

          // newConnection
          //   .invoke("SendNotification", "Hello Manoj")
          //   .catch((err) => {
          //     console.log("Send NOtification error", err);
          //   });

          newConnection.on("ReceiveNotification", (response) => {
            console.log("manoj", response);

            if (response?.application == "Benefit") {
              const audio = audioRef.current;

              if (audio) {
                audio?.play().catch((error) => {
                  console.error("Autoplay was prevented:", error);
                });
              }
              setSnackBarText(response?.message);
              setOpenSnackbar(true);
              // AudioPlayer()
            }
          });

          setConnection(newConnection);
        })
        .catch((error) => console.error("Connection failed: ", error));
    }
  }, [userData]);

  return (
    <Context.Provider value={{ connection: connection }}>
      {/* <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"top" + "right"}
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setOpenSnackbar(!openSnackbar);
        }}
        message={snackbarText}
      /> */}
      <audio ref={audioRef} src={ringtone} type="audio/mpeg" pla>
        Your browser does not support the audio element.
      </audio>
      <SnackbarCustom
        open={openSnackbar}
        setOpen={setOpenSnackbar}
        text={snackbarText}
        application={`${appName} Application`}
      />
      {props.children}
    </Context.Provider>
  );
};

export default SocketProvider;
